module.exports = __webpack_public_path__ + "img/horizontal_3_1_3009.58fda927.png";